import React, { useState } from 'react';
import Lottie from 'react-lottie';
import animationData from '../assets/json/phone.json';
import ContactModal from './ContactModal';

function CallButton() {
  const [contactModal, setContactModal] = useState(false);

  const openContactModal = () => {
    setContactModal(true);
  };

  const closeContactModal = () => {
    setContactModal(false);
  };

  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };


  return (
    <>
    <button
      onClick={openContactModal}
      className="fixed md:bottom-4 md:right-4 right-0 bottom-0 text-white z-40 flex items-center justify-center"
    >
      <Lottie
        options={defaultOptions}
        height={125}
        width={125}
      />
    </button>
    <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
    </>
  );
}

export default CallButton;
